<script setup>
import Footer from "../components/Footer";
</script>

<template>
  <main class="min-vh-100">
    <header class="bg-dark">
      <nav class="d-flex p-3 flex-row align-center justify-content-center">
        <img
          src="https://ventusleasing.mx/wp-content/uploads/2023/04/Logotipo-Ventus-Leasing-Arrendamiento-Puro-Financiamiento-Activos-1-1.png"
          width="100"
          alt=""
        />
      </nav>
    </header>

    <router-view />
    <Footer />
  </main>
</template>

<style >
.bg-dark {
  background: #1a1a1a !important;
}
</style>
